// import Vue from 'vue'

const getters = {
  getTeams: ({
    teams
  }) =>
    teams,
  getCurrentTeam: ({
    currentTeam
  }) =>
    currentTeam
}

export default getters
